
export default {
  name: 'SpacingHeader',
}
